export default "__VITE_ASSET__Btl_GTF6__"